import { Route, Routes } from 'react-router-dom';

import LoginRoutes from 'routes/LoginRoutes';
// import { ManagementRoutes } from 'routes/management';
import { MonitoringRoutes } from 'routes/monitoring';
import PrivateRoute from 'components/route/PrivateRoute';
import AuthorityRoute from 'components/route/AuthorityRoute';
import { MenuInfo } from 'data';
import { ROLE } from 'data/data';
import Error403 from 'pages/Error403';

export default function RootRoutes() {
    const monitoring = MenuInfo.CMMS;
    // const management = MenuInfo.MANAGEMENT;
    // const monitoring = MenuInfo.ROOT;
    
    return (
        <Routes>
             <Route element={<PrivateRoute auth={false} />}> {/* 로그인 하지 않아야 접근 가능 */}
                <Route path={"/auth/*"} element={<LoginRoutes />} errorElement={<Error403 />} />
            </Route>

            <Route element={<PrivateRoute auth={true} />}> {/* 로그인 하지 않아야 접근 가능 */}
                <Route element={<AuthorityRoute pageRole={[ROLE.ALL.code]} />}> {/* 접근권한 체크 Route */}
                    <Route path={monitoring.fullpath + "*"} element={ <MonitoringRoutes/> }/>
                </Route>
                {/* <Route element={<AuthorityRoute pageRole={[ROLE.ALL.code]} />}>  접근권한 체크 Route 
                    <Route path={management.fullpath + "/*"} element={ <ManagementRoutes/> }/>
                </Route> */}
            </Route>

        </Routes>
    );
}